import { useEffect, useState } from "react";
import axios from "axios";
import { BellRing, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—";

const PRODUCT_LABELS = { "repair-hair-mask": "Repair Hair Mask" };

export const WaitlistPanel = () => {
  const [data, setData] = useState(null);
  const [exporting, setExporting] = useState(false);

  const exportCsv = async () => {
    setExporting(true);
    try {
      const res = await axios.get(`${API}/admin/waitlist/export`, {
        withCredentials: true,
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `celusta-waitlist-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${API}/admin/waitlist`, { withCredentials: true })
      .then((res) => setData(res.data))
      .catch(() => setData({ entries: [], count: 0 }));
  }, []);

  const entries = data?.entries || [];

  return (
    <section className="mt-10" data-testid="waitlist-panel">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <BellRing size={16} className="text-[#C9A45C]" />
        <h2 className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#756A64]">
          Launch Waitlist
        </h2>
        <span className="px-2.5 py-0.5 rounded-full bg-[#EDE3D6] text-[10px] font-mono-accent text-[#C9A45C]" data-testid="waitlist-count">
          {data?.count ?? 0}
        </span>
        <button
          onClick={exportCsv}
          disabled={exporting || entries.length === 0}
          className="ml-auto flex items-center gap-1.5 px-4 py-2 rounded-full border border-[rgba(58,42,37,0.2)] text-[11px] font-mono-accent uppercase tracking-[0.1em] text-[#3A2A25] hover:bg-[#EDE3D6] transition-colors duration-300 disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="waitlist-export-button"
        >
          <Download size={13} /> {exporting ? "Exporting…" : "Export CSV"}
        </button>
      </div>
      <div className="bg-[#FFFDF9] rounded-xl border border-[rgba(58,42,37,0.08)] overflow-x-auto" data-testid="waitlist-table">
        {entries.length === 0 ? (
          <p className="p-8 text-sm font-light text-[#9A8D85]" data-testid="waitlist-empty-message">
            No waitlist signups yet.
          </p>
        ) : (
          <table className="w-full text-left text-sm min-w-[480px]">
            <thead>
              <tr className="border-b border-[rgba(58,42,37,0.1)]">
                {["Email", "Product", "Signed up"].map((h) => (
                  <th key={h} className="px-4 py-4 font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#9A8D85]">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id} className="border-b border-[rgba(58,42,37,0.05)]" data-testid={`waitlist-row-${e.email}`}>
                  <td className="px-4 py-3.5 text-[#2B1F1B]">{e.email}</td>
                  <td className="px-4 py-3.5 text-[#756A64]">{PRODUCT_LABELS[e.product] || e.product}</td>
                  <td className="px-4 py-3.5 text-[#756A64] whitespace-nowrap">{formatDate(e.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
};
